/** 이 화면의 2.0 화면코드 — gi24·gi25 가 같이 쓰는 출고조회 API 에 X-Menu-Code 로 실어 감사 로그 MENU_CD 를 가른다(LOGISPRD-15645) */
export const MENU_CODE = 'GI25'
